import moment from 'moment'

export default function (date) {
    const parseDate = moment(date, 'YYYY-MM-DD').toDate()
    const mDate = moment(parseDate).locale('ru')
    return date ? mDate.format('DD.MM.YYYY') : 'Не указано'
}
